export const TrainerActions = {
  TOGGLE_LOADER: '@TrainerActions/TOGGLE_LOADER',
  TOGGLE_ERROR: '@TrainerActions/TOGGLE_ERROR',
  UPDATE_DATA: '@TrainerActions/UPDATE_DATA',
};

const trainerState = {
  isLoading: false,
  isError: false,
  trainerData: {
    agencia: null,
    alongamento: 0,
    artes_marciais: null,
    banco: null,
    cadeirantes: 0,
    cd_experiencia: '',
    cd_formacao: '',
    cd_pf_pj: '',
    cd_status: '',
    celular: '',
    cnpj: null,
    condicionamento_fisico: 0,
    consultorias: null,
    conta: null,
    cpf: '',
    cref: '',
    curriculo: '',
    danca: 0,
    data_alteracao: '',
    data_inclusao: '',
    descricao_experiencia: '',
    doencas_metabolicas: null,
    domingo: null,
    emagrecimento: 0,
    email: '',
    esportes: null,
    foto: '',
    gestantes: 0,
    ginastica_laboral: null,
    hipertrofia: null,
    id_profissional: '',
    instagram: null,
    ja_atuou: 0,
    laboral_online: 0,
    manha_5_9: 0,
    manha_9_12: 0,
    musculacao: null,
    noite_18_21: null,
    noite_21_2: null,
    nome: '',
    objetivos: '',
    palestras: '',
    patologias: null,
    pilates: null,
    porque_leths: '',
    quarta: 0,
    quinta: 0,
    reabilitacoes: 0,
    relaxamento: null,
    sabado: null,
    segunda: 0,
    senha: '',
    seq: 0,
    sexta: 0,
    tarde_12_15: 0,
    tarde_15_18: 0,
    tenis: 0,
    terca: 0,
    terceira_idade: 0,
    treinamento_funcional: null,
    yoga: 0,
  },
  planData: undefined,
  classesData: [],
  personalClassesData: [],
};

const TrainerReducer = (state = trainerState, action) => {
  switch (action.type) {
    case TrainerActions.TOGGLE_LOADER:
      return { ...state, isLoading: !state.isLoading };
    case TrainerActions.TOGGLE_ERROR:
      return { ...state, isError: !state.isError };
    case TrainerActions.UPDATE_DATA:
      return { ...state, [action.dataType]: action.dataValue };
    default:
      return { ...state };
  }
};

export default TrainerReducer;
